import { Link, useLocation } from 'react-router-dom';

import LandingFooter from '@/modules/Pages/shared/LandingFooter';
import LandingNav from '@/modules/Pages/shared/LandingNav';
import LandingReveal from '@/modules/Pages/shared/LandingReveal';
import '@/modules/Pages/shared/landingPage.css';
import { AppRoutes } from '@/utils/routes/router';

type ThankYouLocationState = {
  name?: string;
};

export default function WaitlistThankYouPage() {
  const location = useLocation();
  const state = (location.state as ThankYouLocationState | null) ?? null;
  const firstName = state?.name?.trim().split(/\s+/)[0];

  return (
    <div className="landing-page landing-grain min-h-screen font-sans relative">
      <div className="relative z-10">
        <LandingNav />
        <main className="pt-32 pb-24 px-6 relative overflow-hidden">
          <div
            className="pointer-events-none absolute top-24 left-1/2 -translate-x-1/2 w-[34rem] h-[34rem] rounded-full opacity-30 blur-3xl"
            style={{ background: 'rgba(0, 185, 255, 0.18)' }}
            aria-hidden
          />
          <div
            className="pointer-events-none absolute bottom-10 right-[12%] w-72 h-72 rounded-full opacity-25 blur-3xl"
            style={{ background: 'rgba(255, 190, 0, 0.14)' }}
            aria-hidden
          />

          <div className="max-w-2xl mx-auto relative">
            <LandingReveal>
              <div
                className="landing-card relative overflow-hidden p-8 md:p-12 text-center border-primary"
                style={{
                  background:
                    'linear-gradient(165deg, rgba(0, 185, 255, 0.08) 0%, rgba(14, 28, 42, 0.35) 48%, rgba(255, 190, 0, 0.04) 100%)',
                  boxShadow: '0 0 60px rgba(0, 185, 255, 0.08)',
                }}
              >
                <div
                  className="mx-auto mb-7 flex h-16 w-16 items-center justify-center rounded-full"
                  style={{
                    backgroundColor: 'rgba(0, 185, 255, 0.12)',
                    border: '1px solid rgba(0, 185, 255, 0.35)',
                    boxShadow: '0 0 28px rgba(0, 185, 255, 0.28)',
                  }}
                  aria-hidden
                >
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path
                      d="M5 12.5l4.5 4.5L19 7.5"
                      stroke="#00b9ff"
                      strokeWidth="2.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <p className="landing-section-label mb-4">Waitlist confirmed</p>
                <h1 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-5">
                  {firstName ? `Thank you, ${firstName}.` : 'Thank you.'}
                </h1>
                <p className="landing-prose mb-4 max-w-xl mx-auto">
                  You&apos;ve been added to the ChurnSignal waitlist.
                </p>
                <p className="landing-prose mb-10 max-w-xl mx-auto">
                  We&apos;re receiving a large number of requests right now. We&apos;ll review your application and get
                  back to you as soon as we can.
                </p>

                <div
                  className="mx-auto mb-10 h-[3px] w-16 rounded-full"
                  style={{
                    background: 'linear-gradient(90deg, #ffbe00 0%, #00b9ff 100%)',
                    boxShadow: '0 0 12px rgba(0, 185, 255, 0.45), 0 0 18px rgba(255, 190, 0, 0.25)',
                  }}
                  aria-hidden
                />

                <p className="text-secondary text-sm mb-8 max-w-md mx-auto leading-relaxed">
                  Keep an eye on your inbox — we&apos;ll reach out when early access opens for your team.
                </p>

                <Link
                  to={AppRoutes.home}
                  className="inline-flex px-8 py-4 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                  style={{
                    backgroundColor: '#fafafa',
                    color: '#0e1c2a',
                    boxShadow: '0 8px 32px rgba(250, 250, 250, 0.1)',
                  }}
                >
                  Back to home
                </Link>
              </div>
            </LandingReveal>
          </div>
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
